// src/pages/earningsImport/EarningsUploadSection.js

import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, doc, onSnapshot, setDoc } from "firebase/firestore";

export default function EarningsUploadSection({
  platform,
  setPlatform,
  company,
  setCompany,
  month,
  setMonth,
  week,
  setWeek,
  onFileSelect,
  onProcess,
}) {
  const [platforms, setPlatforms] = useState([]);
  const [newPlatform, setNewPlatform] = useState("");

  /* -------------------------------------------------------
     LOAD ALL PLATFORMS FROM FIRESTORE
  ------------------------------------------------------- */
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "driverPlatformMappings"),
      (snap) => {
        const list = snap.docs.map((d) => d.id);
        setPlatforms(list);
      }
    );
    return () => unsub();
  }, []);

  /* -------------------------------------------------------
     ADD NEW PLATFORM
  ------------------------------------------------------- */
  async function handleAddPlatform() {
    if (!newPlatform.trim()) return alert("Enter a platform name");

    const clean = newPlatform.toLowerCase().replace(/\s+/g, "_");

    await setDoc(doc(db, "driverPlatformMappings", clean), {
      createdAt: new Date().toISOString(),
    });

    alert(`Platform "${clean.toUpperCase()}" added successfully!`);
    setNewPlatform("");
  }

  /* -------------------------------------------------------
     MONTH OPTIONS (current + next year)
  ------------------------------------------------------- */
  /* -------------------------------------------------------
     MONTH OPTIONS (previous + current + next year)
  ------------------------------------------------------- */
const currentYear = new Date().getFullYear();
const monthOptions = [];

for (let year = currentYear - 1; year <= currentYear + 1; year++) {
  for (let i = 0; i < 12; i++) {
    const m = (i + 1).toString().padStart(2, "0");
    const name = new Date(year, i).toLocaleString("en", { month: "long" });

    monthOptions.push({
      value: `${year}-${m}`,
      label: `${m} - ${name} ${year}`,
    });
  }
}

const weekOptions = [1, 2, 3, 4, 5];


  /* -------------------------------------------------------
     RENDER
  ------------------------------------------------------- */
  return (
    <div
      style={{
        padding: 16,
        border: "1px solid #ccc",
        borderRadius: 8,
        background: "#f5f7fa",
        marginBottom: 20,
      }}
    >
      <h3>📤 Ride-Hailing Earnings Upload</h3>

      
      {/* ---------------- PLATFORM ---------------- */}
      <label style={{ fontWeight: "600" }}>Platform</label>
      <select
        value={platform}
        onChange={(e) => setPlatform(e.target.value)}
        style={{ width: "100%", padding: 8, marginBottom: 12 }}
      >
        <option value="">Select Platform</option>
        {platforms.map((p) => (
          <option key={p} value={p}>
            {p.toUpperCase()}
          </option>
        ))}
      </select>

      {/* ---------------- ADD NEW PLATFORM ---------------- */}
      <div
        style={{
          padding: 10,
          background: "#fff",
          border: "1px solid #ccc",
          borderRadius: 6,
          marginBottom: 18,
        }}
      >
        <h4 style={{ margin: "0 0 8px 0" }}>➕ Add New Platform</h4>

        <input
          type="text"
          placeholder="e.g. uber, careem, yango"
          value={newPlatform}
          onChange={(e) => setNewPlatform(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 10,
            borderRadius: 6,
            border: "1px solid #bbb",
          }}
        />

        <button
          onClick={handleAddPlatform}
          style={{
            width: "100%",
            padding: "8px 12px",
            background: "#2e7d32",
            color: "white",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Add Platform
        </button>
      </div>

      {/* ---------------- MONTH ---------------- */}
      <label style={{ fontWeight: "600" }}>Month</label>
      <select
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        style={{ width: "100%", padding: 8, marginBottom: 12 }}
      >
        <option value="">Select Month</option>
        {monthOptions.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>

      {/* ---------------- WEEK ---------------- */}
      <label style={{ fontWeight: "600" }}>Week</label>
      <select
        value={week}
        onChange={(e) => setWeek(e.target.value)}
        style={{ width: "100%", padding: 8, marginBottom: 12 }}
      >
        <option value="">Select Week</option>
        {weekOptions.map((w) => (
          <option key={w} value={`week${w}`}>
            Week {w}
          </option>
        ))}
      </select>

      {/* ---------------- FILE UPLOAD ---------------- */}
      <label style={{ fontWeight: "600" }}>Upload File</label>
      <input
        type="file"
        accept=".csv, .xlsx"
        onChange={onFileSelect}
        style={{ marginBottom: 12 }}
      />

      <button
        onClick={onProcess}
        style={{
          width: "100%",
          padding: "10px 14px",
          background: "#1976d2",
          color: "white",
          borderRadius: 6,
          border: "none",
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        Process File
      </button>
    </div>
  );
}
